import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { notify } from '../utils/notify';

export const LoginPage: React.FC = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!login.trim() || !password.trim()) {
      notify.error('Введите логин и пароль');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/admin/login', { login, password });
      if (response.data.token) {
        localStorage.setItem('adminToken', response.data.token);
        notify.success('Вход выполнен');
        // Используем replace, чтобы нельзя было вернуться на страницу логина через "Назад"
        navigate('/admin', { replace: true });
      }
    } catch (err: any) {
      const msg = err.response?.data?.error || 'Ошибка входа';
      notify.error(msg);
      // Очищаем поля при ошибке
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  // Если уже есть токен — перенаправляем в админку
  React.useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#f5f5f5',
    }}>
      <div style={{
        background: '#fff',
        padding: '40px 30px',
        borderRadius: 12,
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: 400,
      }}>
        <h2 style={{ margin: '0 0 8px 0', fontSize: 24 }}>🔐 Вход в админ-панель</h2>
        <p style={{ color: '#666', margin: '0 0 24px 0' }}>Введите логин и пароль для доступа</p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontWeight: 'bold', marginBottom: 4 }}>Логин</label>
            <input
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '8px 12px', 
                border: '1px solid #ddd', 
                borderRadius: 4,
                fontSize: 16,
              }}
              disabled={loading}
              autoFocus
              autoComplete="username"
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontWeight: 'bold', marginBottom: 4 }}>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '8px 12px', 
                border: '1px solid #ddd', 
                borderRadius: 4,
                fontSize: 16,
              }}
              disabled={loading}
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            style={{
              width: '100%',
              padding: '10px',
              background: '#007AFF',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              fontSize: 16,
              cursor: loading ? 'default' : 'pointer',
              opacity: loading ? 0.6 : 1,
            }}
            disabled={loading}
          >
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
};